import { Button } from "@common/index";
import Lottie from "lottie-react";
import animation from "./data/animation.json";
import styles from "./styles.module.scss";

export const WeKnow = ({ onNextStep, onTrackEvent }) => {
  return (
    <div id="breakdown" className={styles.container}>
      <div className={styles.content}>
        <div className={styles.lottieWrapper}>
          <Lottie animationData={animation} loop={false} />
        </div>
        <div className={styles.hints}>
          <h4>You've just set your first goal! </h4>
          <br />
          Congratulations on starting your journey towards a healthier you
          <br />
        </div>
      </div>
      
      <Button
        variant="walky"
        onClick={() => {
          onNextStep();
          onTrackEvent();
        }}
      >
        Continue
      </Button>
    </div>
  );
};
